import Vue from 'vue';
import { Auth } from "aws-amplify";

// Verbindungsstatus für die Anzeige unten in der Navigation (L2): geprueft = mindestens ein onopen/onclose erlebt
export const verbindung = Vue.observable({ offen: false, geprueft: false });

let websocket = null;
let subscriptions = []
let subscriptionListeners = {}
let eventListeners = {}

let conn = async () => {
    const token = (await Auth.currentSession()).getIdToken().getJwtToken();
    websocket = new WebSocket(`${process.env.VUE_APP_WEBSOCKET_URL}?token=${token}`);
    websocket.onopen = () => {
        verbindung.offen = true;
        verbindung.geprueft = true;

        subscriptions.forEach(topic => {
            eventListeners[topic] = websocket.addEventListener("message", subscriptionListeners[topic]);
            websocket && websocket.send(
                JSON.stringify({
                    message: "subscribe",
                    data: { topic }
                })
            )
        })
    }
    websocket.onclose = () => {
        verbindung.offen = false;
        verbindung.geprueft = true;
        subscriptions.forEach(topic => {
            websocket && websocket.removeEventListener("message", eventListeners[topic]);
        })
        setTimeout(() => {
            conn();
        }, 1000);
    };
}


export default {
    connect: async () => {
        await conn();
    },

    disconnect: () => {
        websocket && websocket.readyState === WebSocket.OPEN && websocket.close();
    },

    subscribe: (topic, listener = () => { }) => {
        subscriptions.push(topic);
        const filteredListener = (event) => {
            const message = JSON.parse(event.data);
            if (message.topic !== topic) {
                return;
            } else {
                listener(message);
            }
        }
        subscriptionListeners[topic] = filteredListener;
        eventListeners[topic] = websocket.addEventListener("message", filteredListener);

        websocket && websocket.readyState === WebSocket.OPEN && websocket.send(
            JSON.stringify({
                message: "subscribe",
                data: { topic }
            })
        );


    },

    unsubscribe: (topic) => {
        subscriptions = subscriptions.filter(item => item != topic);
        websocket && websocket.readyState === WebSocket.OPEN && websocket.send(
            JSON.stringify({
                message: "unsubscribe",
                data: { topic }
            })
        );
        websocket && websocket.removeEventListener("message", subscriptionListeners[topic]);
        subscriptionListeners[topic] = undefined;
        eventListeners[topic] = undefined;
    },

    addEventListener: (listener) => {
        websocket && websocket.addEventListener("message", listener);
    },

    removeEventListener: (listener) => {
        websocket && websocket.removeEventListener("message", listener);
    }

}